<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ titleKey | abpLocalization }}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="confirm()">
    <div class="mb-3">
      <label class="form-label" for="planning-group-label">{{
        'Doc::Planning:GroupLabel' | abpLocalization
      }}</label>
      <input
        id="planning-group-label"
        type="text"
        class="form-control"
        formControlName="label"
        autofocus
      />
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary ms-2" (click)="modal.dismiss()">
    {{ 'ERP::Cancel' | abpLocalization }}
  </button>
  <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="confirm()">
    {{ '::Save' | abpLocalization }}
  </button>
</div>
